import { Toast } from '@shared/components/toast/interfaces';

export const FORGOT_PASSWORD_TOASTS = {
  emailSent: (email: string): Toast => ({
    type: 'success',
    message: `An email was sent to ${email}`,
  }),
} as const;

export const FORGOT_PASSWORD_ERROR_MODAL = {
  title: 'Error requesting password reset',
  message: 'Something went wrong',
} as const;

export const FORGOT_PASSWORD_COURT_ERROR_MODAL = {
  title: 'Court required',
  message:
    'Please select your court/jurisdiction first so we can send the correct password recovery email.',
} as const;
